import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_hr_service.webp';
import "../solution.css"
const HrService = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-[732px]">
                        Keep Your Workforce Engaged
                    </h1>
                    <p className="text-white text-sm max-w-[650px]" data-aos="fade-down">
                        Tekpossible is your go-to expert for maximizing the potential of ServiceNow HR Service Delivery (HRSD). We empower you to design and deliver employee-focused experiences, ensuring seamless collaboration and communication across your hybrid workforce.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
            <div className="bg-[#FFFFFF] mt-6 mb-10">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl">
                        How can ServiceNow's HRSD solutions assist you in reaching your goals?
                    </h1>
                </div>

                <div className="bg-white">
                    <div data-aos="zoom-in-up" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gapgap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-xl xl:text-xl font-semibold max-w-[253px] text-center mt-3">Empower Teams with Self-Service</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[352px]">
                                Streamline system access with a unified portal for multi-department services, enabling employees to access information, request services, and get assistance seamlessly in one place.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-xl xl:text-xl font-semibold max-w-[253px] text-center mt-3">Engage Employees, Anywhere</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[372px]">
                                Boost content management with dynamic microsites, curated experiences, and AI-driven search for personalized employee engagement. Alternate content to keep it fresh and relevant.
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-xl xl:text-xl font-semibold max-w-[203px] text-center mt-3">Streamline HR Record-Keeping</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[350px]">
                                Boost productivity, enhance security, and maintain compliance by seamlessly managing access to confidential data and streamlining document workflows to ensure accurate, up-to-date records.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6" data-aos="zoom-in-up">

                    <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow HRSD Expertise
                    </h1>
                    <h5 className="text-md text-black font-medium text-center max-w-[900px]">Enterprise Onboarding & Transitions | Employee Service Center | Employee Records Management | HR Case Management</h5>

                </div>
            </div>
            
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-up" data-aos-duration="1000" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 max-w-[1000px]">
                        Looking to enhance ServiceNow HRSD solutions tailored to your business requirements?
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default HrService;